import { render, staticRenderFns } from "./SaleOrderList.vue?vue&type=template&id=4508840c&"
import script from "./SaleOrderList.vue?vue&type=script&lang=js&"
export * from "./SaleOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports